import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { submitFilterDTO } from 'src/components/Common/UI/DndTable/types';


const convertToDataTable = (data: IGetPlace[]): IGetPlace[] => {
  const dataTableData: IGetPlace[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllPlaces = async ( {data} : {data: submitFilterDTO | {}}): Promise<IGetPlace[]> => {
  const response =  await axiosDefaultApi.post(`/api/Entities/GetData/Places`, data);
  return convertToDataTable(response as unknown as IGetPlace[]);
  
};

type QueryFnType = typeof getAllPlaces;

type UseGetAllPlacesOptions = {
  data: submitFilterDTO | {};
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllPlaces = ({ data, config }: UseGetAllPlacesOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllPlaces'],
    queryFn: () => getAllPlaces({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};